<template>
    <div>
        <label class="form-label">HTML</label>
        <textarea class="form-control" rows="6" :value="modelValue.html"
            @input="update('html', $event.target.value)"></textarea>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockRawEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
